const __vite_glob_0_145 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 425 233.7\">\n  <title id=\"title-sort-des\">Sort Descending</title>\n  <path stroke=\"none\" d=\"M404.6 0L212.5 192.1 20.4 0z\" />\n  <path fill=\"none\" stroke-width=\"30\" stroke-miterlimit=\"10\" d=\"M10.6 10.6l201.9 201.9L414.4 10.6\" />\n</svg>\n";

export { __vite_glob_0_145 as default };
